// Booking option helpers — populated from the static timetable so the
// dropdowns always match the live schedule editor.
import { TIMETABLE } from "./timetable";

// Which categories are "class-bound" (require class/location/day selection)
const CLASS_BOUND_CATEGORIES = ["kids", "adult", "workshop"];

export function categoryRequiresClassSelection(category) {
  return CLASS_BOUND_CATEGORIES.includes(category);
}

// Filter timetable rows by relevance for a given product category
// (drop-in, term, workshop, etc.). Falls back to all slots if no match.
export function timetableOptionsForCategory(category) {
  const cat = (category || "").toLowerCase();
  if (cat === "kids") return TIMETABLE.filter((s) => s.category === "kids");
  if (cat === "workshop") return TIMETABLE.filter((s) => s.category === "workshop");
  if (cat === "adult") return TIMETABLE.filter((s) => s.category === "adult");
  return TIMETABLE;
}

// All locations seen in the timetable, de-duplicated.
export const ALL_LOCATIONS = Array.from(new Set(TIMETABLE.map((s) => s.location)));

// Age-group options (kept simple + editable). The form chooses one of
// these based on the product category.
export const AGE_GROUPS_KIDS = ["6–8", "9–11", "12–14", "15–17"];
export const AGE_GROUPS_ADULT = ["18–24", "25–34", "35–44", "45+"];

export function ageGroupsForCategory(category) {
  if ((category || "").toLowerCase() === "kids") return AGE_GROUPS_KIDS;
  return AGE_GROUPS_ADULT;
}
